import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"
import { successDialog, errorDialog } from "../helpers/swal_helper"

export default class extends Controller {
  static targets = ["rewardType", "pointsDisplay", "comment", "studentList", "selectedCount", "totalPoints", "submitBtn"]

  connect() {
    // Use event delegation for checkbox changes
    this.studentListTarget.addEventListener('change', (event) => {
      if (event.target.classList.contains('student-checkbox')) {
        this.updateTotalPoints()
      }
    })
  }

  updatePoints() {
    const selectedOption = this.rewardTypeTarget.options[this.rewardTypeTarget.selectedIndex]
    const points = selectedOption?.dataset?.points || 0
    this.pointsDisplayTarget.textContent = points
    this.updateTotalPoints()
  }

  toggleAll(event) {
    const checkboxes = this.studentListTarget.querySelectorAll('.student-checkbox')
    checkboxes.forEach(cb => {
      cb.checked = event.target.checked
    })
    this.updateTotalPoints()
  }

  updateTotalPoints() {
    const selectedCheckboxes = this.studentListTarget.querySelectorAll('.student-checkbox:checked')
    const points = parseInt(this.pointsDisplayTarget.textContent) || 0
    const selectedCount = selectedCheckboxes.length
    const totalPoints = selectedCount * points

    this.selectedCountTarget.textContent = selectedCount
    this.totalPointsTarget.textContent = totalPoints
  }

  fireConfetti() {
    if (window.fireConfetti) {
      window.fireConfetti()
    }
  }

  submitRewards(event) {
    event.preventDefault()

    const rewardTypeId = this.rewardTypeTarget.value
    const comment = this.commentTarget.value
    const levelId = this.element.dataset.bulkRewardLevelId
    const selectedCheckboxes = this.studentListTarget.querySelectorAll('.student-checkbox:checked')

    if (!rewardTypeId) {
      errorDialog("Error", "Please select a reward type")
      return
    }

    if (selectedCheckboxes.length === 0) {
      errorDialog("Error", "Please select at least one student")
      return
    }

    const studentIds = Array.from(selectedCheckboxes).map(cb => cb.value)

    this.submitBtnTarget.disabled = true

    Rails.ajax({
      url: '/rewards/bulk_create',
      type: 'POST',
      dataType: 'json',
      data: new URLSearchParams({
        student_ids: studentIds.join(','),
        reward_type_id: rewardTypeId,
        comment: comment,
        level_id: levelId
      }),
      success: (data) => {
        if (data.success) {
          this.fireConfetti()
          successDialog("Alḥamdulillāh", `Rewards given to ${data.count} students!`)
          $('#bulkRewardModal').modal('hide')
          setTimeout(() => location.reload(), 1500)
        } else {
          errorDialog("Error", data.errors || "Failed to give rewards")
          this.submitBtnTarget.disabled = false
        }
      },
      error: () => {
        errorDialog("Error", "Failed to give rewards. Please try again.")
        this.submitBtnTarget.disabled = false
      }
    })
  }
}
